

(function($, App, Utils){
  'use strict';

  var logger = new Logger('DataDeferSubmit');

  Utils.add('DataDeferSubmit', {

    bindEvents: function() {

      $('*[data-defer-submit]').not('[data-defer-submit=""]').off('click').on('click', function(e) {
        var
          self = $(this),
          formId = self.data('deferSubmit');

        logger.info("Submitting: ", formId);
        $(formId).submit();
      });

      $('*[data-submit]').each(function(i, e) {
        var
          self = $(e),
          evt = self.data('submit'),
          form = self.closest('form');

        self.off(evt).on(evt, function(e) {

          logger.info("Submitting: ", formId);
          form.submit();
        });

      });
    },

    init: function() {
      this.bindEvents();
    }

  });

})(jQuery, window.App, window.App.Utils);
